import { API_URL } from '../config/api.config';
import { api } from './api.util';

const API_BASE_URL = API_URL;

export const fetchMockTests = async (subjectId = null) => {
  try {
    const url = subjectId ? `/mock-tests?subject=${subjectId}` : '/mock-tests';
    const response = await api.get(url);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch mock test packages');
  } catch (error) {
    console.error('Error fetching mock test packages:', error);
    return [];
  }
};

export const getMockTestBySlug = async (slug) => {
  try {
    const response = await api.get(`/mock-tests/slug/${slug}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch mock test package');
  } catch (error) {
    console.error('Error getting mock test package by slug:', error);
    const mockTests = await fetchMockTests();
    const mockTest = mockTests.find((m) => m.slug === slug);
    if (!mockTest) {
      throw new Error(`Mock test package not found: ${slug}`);
    }
    return mockTest;
  }
};

export const getMockTestById = async (id) => {
  try {
    const response = await api.get(`/mock-tests/${id}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch mock test package');
  } catch (error) {
    console.error('Error getting mock test package by ID:', error);
    throw error;
  }
};

export const getSubjectByIdForMockTest = async (subjectId) => {
  try {
    const response = await api.get(`/subjects/${subjectId}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch subject');
  } catch (error) {
    console.error('Error getting subject by ID:', error);
    return {
      _id: subjectId,
      title: `Subject ${subjectId?.slice(-4)}`,
      description: 'Subject details not available',
      exams: [],
      mockTests: []
    };
  }
};

export const fetchSubjectsByMockTest = async (mockTestSlug) => {
  try {
    const mockTest = await getMockTestBySlug(mockTestSlug);
    if (!mockTest) {
      throw new Error(`Mock test package not found: ${mockTestSlug}`);
    }
    const response = await api.get(`/mock-tests/${mockTest._id}/subjects`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch subjects');
  } catch (error) {
    console.error('Error fetching subjects by mock test:', error);
    return [];
  }
};

export const fetchMockTestPdfsBySubject = async (subjectId, mockTestId) => {
  try {
    // Note: mockTestId parameter is kept for API compatibility but not used in filtering
    // PDFs are filtered only by isMockTest=true and subject
    const response = await api.get(`/subjects/${subjectId}/pdfs?isMockTest=true`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch mock test PDFs');
  } catch (error) {
    console.error('Error fetching mock test PDFs by subject:', error);
    return [];
  }
};

export { API_BASE_URL };
